import { NodeTemplate } from "@/components.edit/edit-graph";
import { AssetPointer } from "@/psychlab/types";


export type CognitiveTestParams = {
	useAsset:boolean;
	asset:AssetPointer<any>|null;
	testType:string|null;
	testParameters:any;
}

export const CognitiveTest:NodeTemplate<CognitiveTestParams> = {
	name: "CognitiveTest",
	icon: "head-cog mdi-flip-h text-black-50",
	hide:true,

	parameters:{
		useAsset:false,
		asset:null,
		testType:null,
		testParameters:null
	},
	ports: {
		start: {
			type: "input",
			label: {
				text: "",
				attributes: {
					x: 10
				}
			},
			x: -50
		},
		exit: {
			type: "output",
			label: {
				text: "",
				style: {
					"text-anchor": "end"
				},
				attributes: {
					x: -10
				}
			},
			x: 50
		}
	},
	template:`
	<svg style="overflow:visible" x="-50" y="-50">
		<rect rx="100" ry="100" width="100" height="100" strokeWidth="0" stroke="white" fill="#00bdd6"></rect>
	</svg>
	`
};